import script from "./NewsPageThemesList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageThemesList.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageThemesList.vue?vue&type=style&index=0&id=4bb1bcb9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bb1bcb9"]])

export default __exports__